"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2444],{

/***/ 50720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MainMenuRight": function() { return /* reexport */ MainMenuRight; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/@the-volte/svc-core-sdk/lib/index.js
var lib = __webpack_require__(44859);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/atoms/index.ts + 6 modules
var atoms = __webpack_require__(23920);
// EXTERNAL MODULE: ./src/components/atoms/MainMenu/MenuIcon/MenuIcon.tsx
var MenuIcon = __webpack_require__(15381);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/globalStyles/constants.ts
var globalStyles_constants = __webpack_require__(71467);
;// CONCATENATED MODULE: ./src/images/cart-new.svg
/* harmony default export */ var cart_new = ({"src":"/_next/static/media/cart-new.ea65ef76.svg","height":21,"width":21});
// EXTERNAL MODULE: ./src/images/profile-new.svg
var profile_new = __webpack_require__(36752);
;// CONCATENATED MODULE: ./src/components/atoms/MainMenu/MainMenuRight/MainMenuRight.tsx













var MainMenuRight = function(param) {
    var menu = param.menu, user = param.user, handleSignOut = param.handleSignOut, login = param.login, resetActiveMenu = param.resetActiveMenu;
    var ref;
    var items = (0,lib.useCart)().items;
    var overlayContext = (0,react.useContext)(legacy.OverlayContext);
    var menuItems = (menu === null || menu === void 0 ? void 0 : menu.items) || [];
    var isLoggedIn = !!user;
    var hasAddress = !!(user === null || user === void 0 ? void 0 : (ref = user.addresses) === null || ref === void 0 ? void 0 : ref.length);
    var isStaff = !!(user === null || user === void 0 ? void 0 : user.isStaff);
    var cartItemsQuantity = items && items.reduce(function(prevVal, currVal) {
        return prevVal + currVal.quantity;
    }, 0) || 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
        onMouseEnter: resetActiveMenu,
        flex: {
            base: "1 1 0px",
            lg: "none"
        },
        width: {
            lg: "8.313rem"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginInlineStart: 0,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                    query: {
                        minWidth: globalStyles_constants/* xLargeScreen */.hZ
                    },
                    defaultMatches: __webpack_require__.g.isDesktop,
                    render: function() {
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Flex */.kC, {
                            alignItems: "center",
                            gap: 4,
                            children: [
                                isLoggedIn ? hasAddress || isStaff ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.NavItem, {
                                    name: "Lending",
                                    url: paths/* paths.accountLending */.H.accountLending,
                                    external: true
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.NavItem, {
                                    name: "Lending",
                                    url: "".concat(paths/* paths.accountAddressBook */.H.accountAddressBook, "?fromLending=true")
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.NavItem, {
                                    name: "Log\xa0In",
                                    url: "#",
                                    onClick: login
                                }),
                                isLoggedIn && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.MenuDropdown, {
                                    label: user.firstName,
                                    content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(atoms.MainMenuUserTools, {
                                        isLoggedIn: !!user,
                                        handleSignOut: handleSignOut,
                                        handleLogin: login,
                                        isStaff: !!(user === null || user === void 0 ? void 0 : user.isStaff)
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    cursor: "pointer",
                                    pr: "0.5rem",
                                    onClick: function() {
                                        return overlayContext.show(legacy.OverlayType.cart, legacy.OverlayTheme.right);
                                    },
                                    children: "BAG\xa0(".concat(Number(cartItemsQuantity), ")")
                                })
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                    query: {
                        maxWidth: globalStyles_constants/* xLargeScreen */.hZ - 1
                    },
                    defaultMatches: constants/* ssrMode */.$m && !__webpack_require__.g.isDesktop,
                    render: function() {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuIcon/* default */.Z, {
                            dataTest: "desktopMenuToggleAccountOverlayIcon",
                            onClick: function() {
                                return overlayContext.toggle(legacy.OverlayType.mobileAccount, undefined, {
                                    data: menuItems
                                });
                            },
                            svgSrc: profile_new/* default.src */.Z.src
                        });
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_media/* default */.Z, {
                    query: {
                        maxWidth: globalStyles_constants/* xLargeScreen */.hZ - 1
                    },
                    defaultMatches: constants/* ssrMode */.$m && !__webpack_require__.g.isDesktop,
                    render: function() {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuIcon/* default */.Z, {
                            dataTest: "menuCartOverlayLink",
                            onClick: function() {
                                overlayContext.show(legacy.OverlayType.cart, legacy.OverlayTheme.right);
                            },
                            svgSrc: cart_new.src,
                            textOverlay: cartItemsQuantity > 0 ? String(cartItemsQuantity) : undefined
                        });
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/MainMenu/MainMenuRight/index.ts



/***/ }),

/***/ 15381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MenuIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98547);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63319);
/* harmony import */ var _styles_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71467);






var MenuIcon = function(param) {
    var dataTest = param.dataTest, onClick = param.onClick, svgSrc = param.svgSrc, _visible = param.visible, visible = _visible === void 0 ? true : _visible, textOverlay = param.textOverlay, _iconWidth = param.iconWidth, iconWidth = _iconWidth === void 0 ? "1.438rem" : _iconWidth;
    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M5, {
        "data-test": dataTest,
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick();
        },
        cursor: "pointer",
        paddingRight: {
            base: "1rem",
            xl: "0.5rem"
        },
        display: visible ? "block" : "none",
        _last: {
            paddingRight: 0
        },
        height: "100%",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Center */ .M5, {
            position: "relative",
            height: "18px",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_svg__WEBPACK_IMPORTED_MODULE_1__/* .ReactSVG */ .Q, {
                    src: svgSrc,
                    style: {
                        width: iconWidth
                    }
                }),
                textOverlay && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    top: "2px",
                    left: 0,
                    display: "inline-block",
                    width: {
                        base: "15px",
                        xl: "18px"
                    },
                    height: {
                        base: "15px",
                        xl: "18px"
                    },
                    borderRadius: "50%",
                    margin: "0 auto",
                    backgroundColor: _styles__WEBPACK_IMPORTED_MODULE_2__/* .defaultTheme.colors.primary[500] */ .uH.colors.primary[500],
                    color: _styles__WEBPACK_IMPORTED_MODULE_2__/* .defaultTheme.colors.white */ .uH.colors.white,
                    fontSize: {
                        base: _styles_constants__WEBPACK_IMPORTED_MODULE_3__/* .labelFontSize */ .tz,
                        xl: _styles_constants__WEBPACK_IMPORTED_MODULE_3__/* .smallFontSize */ .oD
                    },
                    lineHeight: {
                        base: "15px",
                        xl: "18px"
                    },
                    textAlign: "center",
                    children: textOverlay
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MenuIcon);


/***/ })

}]);